
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import ModalWarning from 'Common/Components/ModalWarning';
import { TrashIcon } from './styled';
import { deleteAgentExecutions } from 'store/Agents/actions';
import { isEmpty } from 'lodash';
import DeletionModal from '../../../DeletionModal';
import { selectAgentExecutionSelected } from 'store/Agents/selectors';

const Delete = () => {
  const dispatch = useDispatch();
  const [showWarning, setShowWarning] = useState(false);
  const [agentsToDelete, setAgentsToDelete] = useState(null);
  const intl = useIntl();
  const message = intl.formatMessage({ id: 'modalWarning.selectOneOrMore' }, { entity: 'agents' });
  const agentExecutionSelected = useSelector(selectAgentExecutionSelected);

  const onAccept = () => {
    dispatch(deleteAgentExecutions());
    dispatch(setAgentsToDelete(null));
  };

  const handleClick = () => {
    if (isEmpty(agentExecutionSelected)) setShowWarning(true);
    else dispatch(setAgentsToDelete(agentExecutionSelected));
  };

  const onClose = () => {
    setShowWarning(false);
    setAgentsToDelete(null);
  };

  return (
    <>
      <TrashIcon title="Delete" onClick={ handleClick } />
      { showWarning && <ModalWarning onCloseCallback={ onClose } title="Delete" description={ message } /> }
      <DeletionModal agentToDelete={ agentsToDelete } onAccept={ onAccept } onClose={ onClose } runStatusLog />
    </>
  );
};

export default Delete;
